export default function BrandStory() {
  return (
    <section>
      <h2 className="text-xl font-heading text-foreground-900 mb-5">品牌故事</h2>
      <div className="flex flex-col lg:flex-row gap-8">
        <div className="flex-1">
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            踩蘑菇攻略大全诞生于2024年，由一群热爱踩蘑菇游戏的资深玩家共同创立。创始人"蘑菇达人"在通关全部关卡后，发现自己花了大量时间摸索技巧和寻找隐藏要素，于是萌生了创建这个攻略网站的想法——让更多玩家少走弯路，更快享受到游戏的核心乐趣。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            从最初只有三篇基础攻略文章的个人博客，到如今涵盖玩法技巧、关卡攻略、高分秘籍、隐藏要素等六大板块的综合性攻略平台，我们始终秉持一个理念：<strong>让每一位踩蘑菇玩家都能在这里找到需要的答案。</strong>
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed">
            目前我们的团队由5位核心成员组成，包括游戏研究专家、攻略撰写者、视频内容创作者和技术支持。我们每天都会关注最新的游戏动态，确保攻略内容的时效性和准确性。我们的内容已帮助超过50万玩家提升了游戏水平，平均每天有超过1万玩家访问我们的网站。
          </p>
        </div>
        <div className="w-full lg:w-72 flex-shrink-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20team%20of%20five%20friendly%20adventurer%20characters%20standing%20together%20on%20a%20giant%20mushroom%2C%20each%20with%20different%20outfits%20and%20roles%2C%20united%20team%20spirit%2C%20hand-drawn%20illustration%20style%2C%20warm%20sunset%20lighting%2C%20fantasy%20forest%20background%2C%20heartwarming%20teamwork%20atmosphere&width=600&height=500&seq=about-brand-story&orientation=portrait"
            alt="踩蘑菇攻略团队"
            className="w-full h-auto rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
}